import React, { useState } from 'react';
import styled from 'styled-components';
import AddIcon from '@material-ui/icons/Add';

import { colors } from '../../healtheraComponents';

type Props = { keyword: string; onRemove: (keyword: string) => void };

const Keyword = ({ keyword, onRemove }: Props) => {
  const [isRemoved, setIsRemoved] = useState(false);

  const handleRemove = () => {
    setIsRemoved(true);
    onRemove(keyword);
  };

  return (
    <Tag disabled={isRemoved}>
      {keyword}
      {!isRemoved && <CloseIcon onClick={handleRemove} />}
    </Tag>
  );
};

const CloseIcon = styled(AddIcon)`
  && {
    margin-left: 12px;
    width: 15px;
    height: 15px;
    transform: rotate(45deg);
    cursor: pointer;
    border-radius: 50%;
    fill: #f5f5f5;
    background-color: #949494;
    transition: 0.2s ease;
    opacity: 1;

    &:hover {
      opacity: 0.3;
    }

    &:active {
      opacity: 0.1;
    }
  }
`;

const Tag = styled.p<{ disabled: boolean }>`
  overflow: hidden;
  margin: 0;
  display: inline-flex;
  background-color: #f5f5f5;
  color: black;
  padding: 4px 8px;
  border-radius: 100px;
  cursor: default;
  align-items: center;
  transition: all 0.2s ease;

  ${({ disabled }) => disabled && `background-color: ${colors.GRAY_LIGHT};`}
`;

export default Keyword;
